import React from 'react';

interface EmptyStateProps {
  message: string;
  sub?: string;
  icon?: string;
  padding?: number | string;
}

const EmptyState: React.FC<EmptyStateProps> = ({ message, sub, icon, padding }) => (
  <div className="empty-state" style={padding !== undefined ? { padding } : undefined}>
    {icon && <div className="empty-state-icon">{icon}</div>}
    <div className="empty-state-title">{message}</div>
    {sub && <div className="empty-state-sub">{sub}</div>}
  </div>
);

export default EmptyState;
